import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";

@Injectable({
  providedIn: "root"
})
export class TestsService {
  private path = "/tests";

  constructor(private backendService: BackendService) {}

  /*** main ***/
  saveTests(createExam) {
    return this.backendService.post(this.path , createExam);
  }

  deleteTestsById(testId) {
    return this.backendService.post(this.path  + "/" + testId + "/delete", {});
  }

  getTestsById(id) {
    return this.backendService.get(this.path + "/" + id);
  }

  searchTests(currPage: number, pageSize: number, filter: any) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

  /*** topics ***/

  saveTopics(topics, testId) {
    return this.backendService.post(this.path + "/"+  testId + "/topics", topics);
  }
  getTopicsById(topicId, testId) {
    return this.backendService.get(this.path + "/" + testId + "/topics/" + topicId);
  }
  getTopics(testId) {
    return this.backendService.get(this.path + "/" + testId + "/topics");
  }

  deleteTopicsById(topicId, testId) {
    return this.backendService.post(
      this.path + "/"+ testId + "/topics/" + topicId + "/delete",
      {}
    );
  }
  
  /*** sectios ***/

  saveSections(testId, definesection) {
    return this.backendService.post(
      this.path + "/" + testId + "/sections",
      definesection
    );
  }

  getSectionsById(testId, sectionId) {
    return this.backendService.get(
      this.path + "/" + testId + "/sections/" + sectionId
    );
  }

  getSections(testId) {
    return this.backendService.get(this.path + "/" +  testId + "/sections");
  }

  deleteSectionsById(testId, sectionId) {
    return this.backendService.post(
      this.path + "/" + testId + "/sections/" + sectionId + "/delete",
      {}
    );
  }

  saveRegionalLanguages(data, testId, sectionId) {
    return this.backendService.post(
      this.path + "/" + testId + "/sections/" + sectionId + "/languages",
      data
    );
  }

  getRegionalLanguagesById(testId, sectionId, langId) {
    return this.backendService.get(
      this.path + "/" + testId + "/sections/" + sectionId + "/language/" + langId
    );
  }

  /*** rules ***/

  saveRules(rules, testId) {
    return this.backendService.post(this.path + "/" + testId + "/rules", rules);
  }

  searchRules(currPage: number, pageSize: number, filter: any, testId) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };
    return this.backendService.post(this.path + "/" + testId + "/rules/search", data);
  }

  deleteRulesById(testId, ruleId) {
    return this.backendService.post(
      this.path + "/" + testId + "/rules/" + ruleId + "/delete",
      {}
    );
  }

  getRulesById(testId, ruleId) {
    return this.backendService.get(this.path + "/" + testId + "/rules/" + ruleId);
  }

  getRules(testId) {
    return this.backendService.get(this.path + "/" + testId + "/rules");
  }

  pushTest (testid, enable){
    return this.backendService.post(this.path + "/" + testid + "/push", {push: enable, testid: testid});
  }
}
